import { render, staticRenderFns } from "./DocUpload.vue?vue&type=template&id=3bec6250"
import script from "./DocUpload.vue?vue&type=script&lang=js"
export * from "./DocUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports